import styled from 'styled-components'
import { LinkEditUnstyled } from './unstyled'

export const LinkEdit = styled(LinkEditUnstyled)`
  fill: ${props => props.theme.colors.regentGray};
  font-size: ${props => props.theme.fontSizes.city.card.link};
  color: ${props => props.theme.colors.regentGray};
  display: inline-block;
  line-height: 16px;

  &:hover {
    text-decoration: none;
  }

  svg {
    height: 15px;
    width: 14px;
    margin-right: 7px;
  }
`



// WEBPACK FOOTER //
// ./src/Components/Link/Edit/index.js